import { getApp, initializeApp } from "firebase/app"
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions"
import { firebaseConfig } from "../firebaseConfig"
import type { LandingLocale } from "./landingCopy"

let app
try {
  app = getApp()
} catch {
  app = initializeApp(firebaseConfig)
}
const functions = getFunctions(app, "europe-west1")
if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001)
}

const submitLandingContactFunc = httpsCallable(functions, "submitLandingContactFunc")

export async function submitLandingContact(input: {
  name: string
  email: string
  message: string
  companyWebsite?: string
  locale: LandingLocale
}) {
  const res = await submitLandingContactFunc(input)
  return res.data as { ok?: boolean; status?: string; message?: string }
}
